import { HttpApiEndpoint, HttpApiGroup } from "@effect/platform";
import * as S from "effect/Schema";
import { PrincipalMiddleware } from "./principal.js";
import { Forbidden } from "./shares.js";
import { MeasureRow } from "./measures.js";
/**
 * A comma-joined id list on the wire, decoded to an array — the same
 * encoding `employees.ListEmployeesParams.location_ids` uses.
 */
const UuidCsvList = S.transform(S.String, S.Array(S.UUID), {
    strict: true,
    decode: (s) => s
        .split(",")
        .map((t) => t.trim())
        .filter((t) => t.length > 0),
    encode: (ids) => ids.join(","),
});
/**
 * The measure-overview card's three counts, aggregated server-side over
 * `vw_measures`/`vw_measure_assignments` — a location-manager's own
 * `location_ids` scope always wins over any `location_ids` param (never
 * trusting the caller with a wider scope than their session grants,
 * matching `employees.listEmployees`'s own rule).
 */
export const MeasureOverviewCounts = S.Struct({
    open: S.Int,
    overdue: S.Int,
    assignedToYou: S.Int,
});
export const GetMeasureOverviewCountsParams = S.Struct({
    client_id: S.UUID,
    location_ids: S.optional(UuidCsvList),
});
export const GetMeasureOverviewCounts = HttpApiEndpoint.get("getMeasureOverviewCounts", "/insights/measure-overview")
    .setUrlParams(GetMeasureOverviewCountsParams)
    .addSuccess(S.Struct({ data: MeasureOverviewCounts }))
    .addError(Forbidden, { status: 403 });
/**
 * The risk-calculation card for one location (or the whole client when
 * `location_id` is omitted) — folds what the legacy screen fetched as three
 * sequential `vw_measures` aggregate calls into one round trip.
 * `requiredActions` counts `topMeasures` assigned to the caller, matching
 * the legacy client-side `.filter(...includes(user.id))` over that same
 * top-5 slice rather than the whole matching set.
 */
export const RiskScoreSummary = S.Struct({
    riskScore: S.Number,
    highestScore: S.Int,
    requiredActions: S.Int,
    topMeasures: S.Array(MeasureRow),
});
export const GetRiskScoreSummaryParams = S.Struct({
    client_id: S.UUID,
    location_id: S.optional(S.UUID),
});
/** `location_id` names a location outside the caller's own `location_ids` scope (location-managers only). */
export const LocationNotInScope = S.Struct({
    _tag: S.Literal("LocationNotInScope"),
});
export const GetRiskScoreSummary = HttpApiEndpoint.get("getRiskScoreSummary", "/insights/risk-score")
    .setUrlParams(GetRiskScoreSummaryParams)
    .addSuccess(S.Struct({ data: RiskScoreSummary }))
    .addError(LocationNotInScope, { status: 403 })
    .addError(Forbidden, { status: 403 });
export const insightsGroup = HttpApiGroup.make("insights")
    .add(GetMeasureOverviewCounts)
    .add(GetRiskScoreSummary)
    .middleware(PrincipalMiddleware);
//# sourceMappingURL=insights.js.map